import React, { useRef, useState, useEffect } from "react";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Input,
    Button
} from "reactstrap";
// core components
import Header from "../../../components/headers/Header";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { Select, Checkbox } from "antd";
import "antd/dist/antd.css";
import HTMLEditor, { ReplaceUrlWithVirtualPath } from "../../../components/ui/HTMLEditor";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/bbs/EditRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";
import MessageBox from "../../../components/ui/MessageBox";

const uid = UIDs.screens.admin.bbs.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_ASYNC]: { done: this._handleSaveAsyncDone, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id, src } = this.localVars.navParams;
        this.props.loadScreenViewAsync({id, partnerId: this.props.partnerId});
    }

    render() {
        const { postInfo, classList, selectedClasses } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!postInfo || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    postInfo={postInfo}
                                    classList={classList}
                                    selectedClasses={selectedClasses}
                                    onCancel={this._handleCancelEdit}
                                    onSave={this._handleSave}
                                    onSelectClass={this._handleSelectClass}
                                    isDisabled={this.isActionExecuting(ActionTypes.SAVE_ASYNC)}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleSave = (data) => {
        let {id, classId, title, tags, html, /*tagsCustom*/} = data;
        let newTags = tags;
        let newArr = [];
        let arr = [];
        //let arrCustom = [];

        if(tags){
            arr = tags.split(",");
        }

        /*if(tagsCustom)
        {
            arrCustom = tagsCustom.split("\n");
        }*/

        for(var i=0;i<arr.length;i++){
            if(arr[i]){
                newArr.push(arr[i]);
            }
        }

        /*for(var i=0;i<arrCustom.length;i++){
            if(arrCustom[i]){
                newArr.push(arrCustom[i]);
            }
        }*/

        newArr = Array.from(new Set(newArr));
        if(newArr.length > 5){
            MessageBox.danger(this.props.t("maxTags"));
            return;
        }
        newTags = newArr.join("\n");
        let newData = {
            id,
            classId,
            title,
            tags: newTags,
            type: "HTML",
            data: JSON.stringify({
                html,
            }),
            partnerId: this.props.partnerId
        }

        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        data = { ...newData }
                        this.props.saveAsync(data);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleCancelEdit = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleSaveAsyncDone = () => {
        if(this.localVars.navParams.src === "me"){
            NavigationService.navigateToPageByUID(this, UIDs.screens.admin.bbs.me, null);
        }else{
            NavigationService.navigateToPageByUID(this, UIDs.screens.admin.bbs.list, null);
        }
    }

    _handleSelectClass = (id) => {
        this.props.selectClass(id);
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

function EditForm(props) {
    const { postInfo, classList, selectedClasses } = props;
    const { id, title, description, unitCount, classId, tags, data } = postInfo;
    const { register, handleSubmit, errors, setValue, clearError } = useForm();
    const submitRef = useRef();
    const newData = JSON.parse(data || null);
    const {html = ""} = newData || {};
    let init_html = html;
    const defTags = ["发音", "词汇", "语法", "修辞", "汉字", "写作", "跨文化", "我的故事"];
    var arrTags = [];
    //let useDef = [];
    //let tagsCustom = [];
    if(id && tags){
        arrTags = tags.split("\n");

        /*for(var i=0; i<arrTags.length;i++){
            if(defTags.indexOf(arrTags[i])>=0){
                useDef.push(arrTags[i]);
            }
            else{
                tagsCustom.push(arrTags[i]);
            }
        }*/
    }
    //let strTagsCustom = tagsCustom.length>0 ? tagsCustom.join("\n") : "";
    const [state_html, setstate_html] = useState(init_html);
    //const [state_tags, setstate_tags] = useState(useDef);
    const [state_tags, setstate_tags] = useState(arrTags);

    const selectClass = (id) => {
        props.onSelectClass(id);
    }

    return (
        <form onSubmit={handleSubmit(props.onSave)}>
            <Card className="shadow">
                <CardHeader className="bg-white border-0">
                    <Row className="align-items-center">
                        <Col xs="8">
                            <h3 className="mb-0">{props.t(id ? "edit" : "create")}</h3>
                        </Col>
                        <Col className="text-right" xs="4">
                            <Button
                                color="info"
                                onClick={() => submitRef.current.click()}
                                size="sm">
                                {props.t("save")}
                            </Button>&nbsp;
                            <Button
                                color="default"
                                onClick={props.onCancel}
                                disabled={props.isDisabled}
                                size="sm">
                                {props.t("cancel")}
                            </Button>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody>
                    <input name="id" hidden type="text" defaultValue={id} ref={register} />
                    <input name="html" hidden type="text"
                           defaultValue={init_html} ref={register({ required: true })} />
                    <input name="classId" hidden type="text" value={Array.from(selectedClasses)} ref={register({ required: true })} />
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("class")}</label>
                                    <div>
                                    {classList && classList.map((item, i) => {
                                        return (
                                            item.visibility === 1 ? null : <div style={{ marginRight: 50, float:"left" }}>
                                                <Input addon type="checkbox" style={{ verticalAlign: "middle", margin: "2px 10px 0 0", cursor: "pointer" }}
                                                    checked={selectedClasses.has(item.id)} onChange={() => { selectClass(item.id); }} />
                                                <label style={{ verticalAlign: "middle", margin: 0, cursor: "pointer" }}>{item.name}</label>
                                            </div>
                                        )
                                    })}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                {errors.classId && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                            </div>
                        </div>
                        <div className="row" style={{marginTop:20}}>
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("title")}</label>
                                    <input name="title" type="text" className="form-control-alternative form-control" defaultValue={title}
                                        ref={register({ required: true })} />
                                    {errors.title && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("tags")}</label>
                                    <span style={{fontSize:12, color:"#757575"}}> ({props.t("tagsDesc")})</span>
                                    <Select
                                        mode="tags"
                                        size="large"
                                        style={{ width: '100%', paddingBottom:10 }}
                                        placeholder={props.t("tags0")}
                                        value={state_tags}
                                        onChange={val => {
                                            setstate_tags(val);
                                        }}
                                        optionFilterProp="label"
                                    >
                                        {defTags.map((choice, j) => {
                                            return <Select.Option key={choice} value={choice} label={choice}>{choice}</Select.Option>
                                        })}
                                    </Select>
                                    <input hidden name="tags" type="text" className="form-control-alternative form-control" value={state_tags}
                                        ref={register} />

                                    {/*<textarea name="tagsCustom" type="text" rows={3} className="form-control-alternative form-control"
                                        placeholder={props.t("tagsDescCustom")}
                                        defaultValue={strTagsCustom}
                                        ref={register}>
                                    </textarea>*/}

                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("html")}</label>
                                    <HTMLEditor height={450}
                                        htmlContent={state_html}
                                        initHtml={init_html}
                                        handleChangeEdit={(v) => {
                                            setValue("html", ReplaceUrlWithVirtualPath(v));
                                            setstate_html(v);
                                        }}
                                    />
                                    {errors.html && <div className="text-danger" style={{marginTop:-20}}>{props.t("fieldIsRequired")}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </CardBody>
            </Card>
        </form>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        partnerId: state.session.partner ? state.session.partner.id : null
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: vo => dispatch(Actions.loadScreenViewAsync(vo)),
        saveAsync: vo => dispatch(Actions.saveAsync(vo)),
        selectClass: id => dispatch(Actions.selectClass(id)),
        create: () => dispatch(Actions.create())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
